// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"arrow-left-up"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15.7782 8L8 8L8 15.7782M8.87946 8.87946L16.0257 16.0257","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ArrowLeftUpIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'arrow-left-up',
    ref,
    icon: element,
  },
));

ArrowLeftUpIcon.displayName = 'ArrowLeftUpIcon';

export default ArrowLeftUpIcon;
